import { render, staticRenderFns } from "./angleDown.vue?vue&type=template&id=2de2d71c&"
import script from "./angleDown.vue?vue&type=script&lang=ts&"
export * from "./angleDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports